import Vue from 'vue'
import VueRouter from 'vue-router';
import { router } from "@/router.js";
import App from '@/App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from "vue2-google-maps";
require("vue-multiselect/dist/vue-multiselect.min.css");
import "@/assets/scss/style.scss";

Vue.config.productionTip = false;
Vue.use(VueRouter);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDB32li1NLpQ3pD5mLzX0HGwzcJy1xfLhg",
    libraries: "places" // necessary for places input
  }
});

library.add(fas);

Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
